export { default as Divider } from "./Divider";
